(function () {
  'use strict';

  angular.module('settings.api').factory('SettingsApi', SettingsApi);

  SettingsApi.$inject = ['$resource'];

  function SettingsApi($resource) {
    return $resource(
      '/api/',
      {},
      {
        getApiKey: { method: 'GET', url: 'api/api_key' },
      },
    );
  }
})();
